import { Fragment, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import {
  Box,
  createStyles,
  TableBody,
  TableCell,
  TableRow,
  withStyles,
} from "@material-ui/core";
import { Row } from "../../../modules/list-pc/types";
import classes from "./index.module.scss";
import { Utils } from "modules/utils";
import { APSAPI } from "modules/uri";
import { useHistory } from "react-router-dom";
import iconDownload from "../../../assets/images/icon_download.png"
import React from "react";
import Modal from "../../../modules/UserModal";
import { isIOSWebview } from "utils/device.utils";

const StyledTableRow = withStyles(() =>
  createStyles({
    root: {
      // "&:nth-of-type(odd)": {
      //   backgroundColor: `#EEEEEE`,
      // },
    },
  })
)(TableRow);

const getToken = () => {
  return localStorage.getItem("token");
};

const getInvoice = async (
  id: string,
  token: string,
  download: boolean
) => {
  try {
    const data = { letterId: id, token: token };
    const resp = await fetch(
      download ? `${APSAPI}/get-letter-file` : `${APSAPI}/get-letter-file`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ formDataJson: data }),
      }
    );

    const respData = await resp.json();
    return respData;
  } catch (err) {
    return null;
  }
};

// const showPdf = async (
//   id: string,
//   token: string,
//   history: any
// ) => {
//   const resp = await getInvoice(id, token, false);

//   if (resp && resp.status === "SUCCESS") {
//     const blob = Utils.b64toBlob(resp.formDataJson.file, "application/pdf");

//     const a = document.createElement("a");
//     document.body.appendChild(a);

//     const url = window.URL.createObjectURL(blob);
//     a.href = url;
//     a.target = "_blank";
//     a.click();

//     setTimeout(() => {
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
//     }, 0);

//     return;
//   }

//   history.goBack();
// };

const downloadZipFile = async (
  id: string,
  token: string,
  history: any,
  setIsDownload: Function,
  setSuccess: Function
) => {
  setIsDownload(true);
  const resp = await getInvoice(id, token, true);

  if (resp && resp.status === "SUCCESS") {
    const mimeType = "application/pdf";
    const blob = Utils.b64toBlob(resp.formDataJson.file, mimeType);

    const a = document.createElement("a");
    document.body.appendChild(a);

    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = resp.formDataJson.filename;
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
    setIsDownload(false);
    setSuccess(true)

    return;
  }
  setIsDownload(false);
  history.goBack();
};

const iosModal = <p style={{textAlign: 'justify'}}>
Chức năng tải tài liệu không thích hợp với thiết bị hiện tại, vui lòng sao chép liên kết <span style={{color: '#ec1b2e', cursor: 'pointer'}} onClick={() => navigator.clipboard.writeText('https://khachhang.prudential.com.vn/customer-portal/web/apsletterweb/index.html')}>Tại đây</span> và thử lại bằng trình duyệt
</p>

export const TableDataColumns = (row: Row, key: number): JSX.Element => {
  const token = getToken()
  const history = useHistory()
  const productName = row.mainProduct.toUpperCase()
  const policy = row.policyNum

  const [error, setError] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);
  const [isDownload, setIsDownload] = useState(false)

  return (
    <Fragment>
      <StyledTableRow hover key={`` + key}>
        <TableCell align="left"
          style={{
            fontSize: `18px`,
            fontFamily: `Noto Sans`,
          }}>
          <strong>{policy}</strong>&nbsp;&nbsp;{productName}
        </TableCell>
        <TableCell
          align="left"
          style={{
            fontSize: `18px`,
            fontFamily: `Noto Sans`,
          }}>
          {row.policyNum && row.letterId ? (
            <Box display="flex" alignItems="left" justifyContent="left">
              {/* <a
                href="/#"
                className={classes.downloadLink}
                onClick={(e) => {
                  e.preventDefault();
                  token && showPdf(row.letterId, token, history);
                }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <span>Xem</span>
                </Box>
              </a> */}
              {isDownload ?
                <div className={classes.loadingBtn}>
                  <CircularProgress />
                </div>
                :
                <a
                  href="/#"
                  className={classes.downloadLink}
                  onClick={(e) => {
                    e.preventDefault()
                    
                    isIOSWebview()
                      ? setError(true)
                      : token && downloadZipFile(row.letterId, token, history, setIsDownload, setSuccess);
                  }}
                >
                  <Box display="flex" alignItems="center" justifyContent="center">
                    <span className={`DownloadLetter ${row.mainProductCode}`}>
                      Tải về 
                      <img
                        className={`DownloadLetter ${row.mainProductCode}`}
                        alt="img" 
                        style={{ paddingLeft: '5px', height: '18px', width: '18px' }} 
                        src={iconDownload}>
                      </img>
                    </span>
                  </Box>
                </a>
              }
  
            </Box>
          ) : (
            ``
          )}
        </TableCell>
      </StyledTableRow>
      
      <Modal
        title="Thông báo"
        children={iosModal}
        titleSubmit="Thoát"
        open={error}
        handleSubmit={() => setError(false)}
      />

      <Modal
        title="Thông báo"
        titleSubmit="Thoát"
        content="Tải thư hoàn tất"
        open={success}
        handleSubmit={() => setSuccess(false)}
      />
    </Fragment>    
  );
};

export const TableDataMobile = (row: Row): JSX.Element => {
  const token = getToken();
  const history = useHistory();
  const [error, setError] = React.useState<boolean>(false);
  const [success, setSuccess] = React.useState<boolean>(false);
  const [isDownload, setIsDownload] = useState(false);
  const productName = row.mainProduct.toUpperCase()
  const policy = row.policyNum
  return (
    <Fragment>
      <TableBody>
        <TableRow>
          <TableCell
            style={{
              width: `400px`,
              fontSize: `18px`,
              fontFamily: `Noto Sans`,
              fontWeight: `bold`,
            }}>Hợp đồng</TableCell>
          <TableCell style={{
            fontSize: `18px`,
            fontFamily: `Noto Sans`,
          }}><strong>{policy}</strong>&nbsp;&nbsp;{productName}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{
            width: `400px`,
            fontSize: `18px`,
            fontFamily: `Noto Sans`,
            fontWeight: `bold`,
          }}>Thông báo tình trạng hợp đồng bảo hiểm</TableCell>
          <TableCell style={{
            fontSize: `18px`,
            fontFamily: `Noto Sans`,
          }}>
            {row.policyNum && row.letterId ? (
              <Box display="flex" alignItems="center">
                {/* <a
                  href="/#"
                  className={classes.downloadLink}
                  onClick={(e) => {
                    e.preventDefault();
                    token && showPdf(row.letterId, token, history);
                  }}
                >
                  <Box display="flex" alignItems="center" justifyContent="center">
                    <span>Xem</span>
                  </Box>
                </a> */}
                {isDownload ?
                  <div className={classes.loadingBtn}>
                    <CircularProgress />
                  </div>
                  :
                  <a
                    href="/#"
                    className={classes.downloadLink}
                    onClick={(e) => {
                      e.preventDefault();

                      isIOSWebview()
                        ? setError(true)
                        : token && downloadZipFile(row.letterId, token, history, setIsDownload, setSuccess);
                    }}
                  >
                    <Box display="flex" alignItems="center" justifyContent="center">
                      <span className={`DownloadLetter ${row.mainProductCode}`}>
                        Tải về 
                        <img
                          className={`DownloadLetter ${row.mainProductCode}`}
                          alt="img" 
                          style={{ paddingLeft: '5px', height: '18px', width: '18px' }} 
                          src={iconDownload}>
                          </img>
                        </span>
                    </Box>
                  </a>
                }
              </Box>
            ) : (
              ``
            )}
          </TableCell>
        </TableRow>
      </TableBody>

      <Modal
        title="Thông báo"
        children={iosModal}
        titleSubmit="Thoát"
        open={error}
        handleSubmit={() => setError(false)}
      />

      <Modal
        title="Thông báo"
        titleSubmit="Thoát"
        content="Tải thư hoàn tất"
        open={success}
        handleSubmit={() => setSuccess(false)}
      />
    </Fragment>
  );
};